const API_BASE = process.env.REACT_APP_API_URL || '';

function getHeaders() {
  const headers = { 'Content-Type': 'application/json' };
  
  // Telegram WebApp auth
  if (window.Telegram?.WebApp?.initData) {
    headers['X-Telegram-InitData'] = window.Telegram.WebApp.initData;
  } else {
    // Dev mode
    headers['X-Dev-User'] = '100001';
  }
  
  return headers;
}

async function request(url, opts = {}) {
  const res = await fetch(API_BASE + url, {
    headers: getHeaders(),
    ...opts,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Network error' }));
    throw new Error(err.error || 'Request failed');
  }
  return res.json();
}

// Stats
export const getStats = () => request('/api/stats');

// Admin CRM
export const getAdminLeads = () => request('/api/admin/leads');

// Objects
export const getObjects = (params = '') => request('/api/objects' + (params ? '?' + params : ''));
export const getObject = (id) => request('/api/objects/' + id);
export const createObject = (data) => request('/api/objects', { method: 'POST', body: JSON.stringify(data) });
export const updateObject = (id, data) => request('/api/objects/' + id, { method: 'PATCH', body: JSON.stringify(data) });
export const deleteObject = (id) => request('/api/objects/' + id, { method: 'DELETE' });
export const deleteObjectPhoto = (id, photoId) => request(`/api/objects/${id}/photos/${photoId}`, { method: 'DELETE' });
export const deleteObjectDocument = (id, docId) => request(`/api/objects/${id}/documents/${docId}`, { method: 'DELETE' });
// FormData: Content-Type ставит браузер (boundary), поэтому свой заголовок убираем
export const addObjectPhotos = async (id, formData) => {
  const headers = getHeaders();
  delete headers['Content-Type'];
  const res = await fetch(`${API_BASE}/api/objects/${id}/photos`, { method: 'POST', headers, body: formData });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Network error' }));
    throw new Error(err.error || 'Request failed');
  }
  return res.json();
};

// Questions
export const getQuestions = (params = '') => request('/api/questions' + (params ? '?' + params : ''));
export const getQuestion = (id) => request('/api/questions/' + id);
export const createQuestion = async (formData) => {
  const headers = {};
  if (window.Telegram?.WebApp?.initData) {
    headers['X-Telegram-InitData'] = window.Telegram.WebApp.initData;
  } else {
    headers['X-Dev-User'] = '100001';
  }
  const res = await fetch(API_BASE + '/api/questions', { method: 'POST', headers, body: formData });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Ошибка сети' }));
    throw new Error(err.error || 'Не удалось отправить вопрос');
  }
  return res.json();
};
export const answerQuestion = async (id, formData) => {
  const headers = {};
  if (window.Telegram?.WebApp?.initData) {
    headers['X-Telegram-InitData'] = window.Telegram.WebApp.initData;
  } else {
    headers['X-Dev-User'] = '100001';
  }
  const res = await fetch(API_BASE + '/api/questions/' + id + '/answer', { method: 'POST', headers, body: formData });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Ошибка сети' }));
    throw new Error(err.error || 'Не удалось отправить ответ');
  }
  return res.json();
};

// Events
export const getEvents = (params = '') => request('/api/events' + (params ? '?' + params : ''));
export const getEvent = (id) => request('/api/events/' + id);
export const registerEvent = (id) => request('/api/events/' + id + '/register', { method: 'POST' });
export const unregisterEvent = (id) => request('/api/events/' + id + '/register', { method: 'DELETE' });

// Library
export const getLibrary = () => request('/api/library');
export const getLibraryCategory = (cat, params = '') => request('/api/library/' + cat + (params ? '?' + params : ''));
export const getLibraryItem = (id) => request('/api/library/item/' + id);

export const getLibraryFolders = (catSlug) => request('/api/library/folders/' + catSlug);
export const searchLibrary = (q) => request('/api/library/search?q=' + encodeURIComponent(q));

// Subscription
export const getSubscription = () => request('/api/subscription');

// Клуб-чат: в группе ли пользователь + персональная ссылка на вступление
export const getClubStatus = () => request('/api/subscription/club-status');
export const getClubInvite = () => request('/api/subscription/club-invite');

// Card application (послеоплатная анкета карточки fix-hub.de)
export const getCardApplication = () => request('/api/card-application');
export const submitCardApplication = (values) => request('/api/card-application', { method: 'POST', body: JSON.stringify({ values }) });
export const saveCardDraft = (draft) => request('/api/card-application/draft', { method: 'POST', body: JSON.stringify(draft) });
export const setPostpayHidden = (hidden) => request('/api/card-application/hide', { method: 'POST', body: JSON.stringify({ hidden }) });
export const postpayDone = () => request('/api/subscription/postpay-done', { method: 'POST' });

// Заявка на доступ к Chat-Angebot.de (экран с кнопки «Попробовать» на главной)
export const getChatAngebotRequest = () => request('/api/chat-angebot');
export const submitChatAngebotRequest = (data) => request('/api/chat-angebot', { method: 'POST', body: JSON.stringify(data) });
// 🧪 Админ-инструменты для прогона воронки: тест-оплата (фейк) и сброс аккаунта «с нуля».
export const testPay = (plan, period) => request('/api/subscription/test-pay', { method: 'POST', body: JSON.stringify({ plan, period }) });
export const testReset = () => request('/api/subscription/test-reset', { method: 'POST' });
export const uploadCardFiles = async (formData) => {
  const headers = {};
  if (window.Telegram?.WebApp?.initData) headers['X-Telegram-InitData'] = window.Telegram.WebApp.initData;
  else headers['X-Dev-User'] = '100001';
  const res = await fetch(API_BASE + '/api/card-application/upload', { method: 'POST', headers, body: formData });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Ошибка загрузки' }));
    throw new Error(err.error || 'Не удалось загрузить файлы');
  }
  return res.json();
};
export const markNotificationsRead = () => request('/api/subscription/notifications/read', { method: 'POST' });
export const getSubscriptionPortal = () => request('/api/subscription/portal', { method: 'POST' });
// Пакеты: цены + Stripe-ссылки из настроек админки (страница пакетов)
export const getPlansConfig = () => request('/api/subscription/plans');
// Промокод: активация акции (вся валидация на сервере)
export const redeemPromoCode = (code) => request('/api/promo/redeem', { method: 'POST', body: JSON.stringify({ code }) });

// AI Assistant
export const sendAssistantMessage = (message, history) => request('/api/assistant', { method: 'POST', body: JSON.stringify({ message, history }) });

// Onboarding quiz & funnel analytics (Task 1.2)
// v5: payload-объект — segment, priorities[], region + профилирующие team_size/has_website/marketing[]
export const sendOnboardingQuiz = (payload) =>
  request('/api/onboarding/quiz', { method: 'POST', body: JSON.stringify(payload) });

// v5.1: анкета блока «развилка→оплата» — { first_name, last_name, phone, path }
export const sendProfile = (payload) =>
  request('/api/onboarding/profile', { method: 'POST', body: JSON.stringify(payload) });

export const sendFunnelEvent = (step, meta) =>
  request('/api/onboarding/event', { method: 'POST', body: JSON.stringify({ step, meta: meta || null }) })
    .catch(() => {}); // fire-and-forget — не блокируем UI

// Заявка на экскурсию из воронки (вместо самозаписи в Calendly): тикет + DM менеджерам.
export const requestTour = () =>
  request('/api/onboarding/tour-request', { method: 'POST', body: JSON.stringify({}) });

export const sendPhone = (phone) =>
  request('/api/onboarding/phone', { method: 'POST', body: JSON.stringify({ phone }) })
    .catch(() => {}); // fire-and-forget

export const sendReferral = (inviter_id) =>
  request('/api/onboarding/referral', { method: 'POST', body: JSON.stringify({ inviter_id }) })
    .catch(() => {}); // fire-and-forget — не блокируем UX

export const getOnboardingProfile = () => request('/api/onboarding/profile');

export const postOnboardingConsent = (data) =>
  request('/api/onboarding/consent', { method: 'POST', body: JSON.stringify(data) });

// Referral dashboard
export const getReferralStats = () => request('/api/referral/stats');

// ── Темы эксперта ──
export const getExpertTopics = () => request('/api/expert/topics');
export const saveExpertTopics = (topics) => request('/api/expert/topics', { method: 'POST', body: JSON.stringify({ topics }) });

